import styled from "styled-components";

export const TitleHeadingDescriptionWrapper = styled.div`
  @media (min-width: ${props => props.theme.ui.breakpoints.md}) {
    max-width: 768px;
    margin: 0 auto;
  }
`;
